const NAME = "ALERT_PAGE";

export default NAME;
